export default __webpack_public_path__ + "static/media/verifiedandproject.5acd4b15.svg";